import {
  Box,
  DrawerBody,
  DrawerHeader,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';

import { BiReport } from '../../../services/biService';
import { DrawerComponent } from '../Drawer';
import { CommentsPanel } from './CommentsPanel';

interface Props {
  report: BiReport;
  isOpen: boolean;
  onClose: () => void;
  currentPage?: string;
  initialTab?: number;
}

function Detail({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Text fontSize="xs" color="gray.500">
        {label}
      </Text>
      <Text fontSize="sm">{value}</Text>
    </Box>
  );
}

export function ReportInfoDrawer({
  report,
  isOpen,
  onClose,
  currentPage,
  initialTab = 0,
}: Props) {
  return (
    <DrawerComponent
      isOpen={isOpen}
      onClose={onClose}
      placement="right"
      size="md"
    >
      <DrawerHeader borderBottomWidth="1px" pr="12">
        {report.reportName}
      </DrawerHeader>

      <DrawerBody py="5">
        <Tabs
          variant="soft-rounded"
          colorScheme="blue"
          defaultIndex={initialTab}
        >
          <TabList mb="4">
            <Tab>Sobre</Tab>
            <Tab>Comentários</Tab>
          </TabList>

          <TabPanels>
            <TabPanel p="0">
              <Stack spacing="5">
                <Box>
                  <Text
                    fontWeight="bold"
                    color="gray.400"
                    fontSize="small"
                    mb="2"
                  >
                    O QUE MOSTRA
                  </Text>
                  <Text
                    fontSize="sm"
                    whiteSpace="pre-wrap"
                    color={report.description ? undefined : 'gray.500'}
                  >
                    {report.description ||
                      'O administrador ainda não descreveu este relatório.'}
                  </Text>
                </Box>

                <Stack spacing="3">
                  <Detail
                    label="Responsável"
                    value={report.owner?.name || 'Não informado'}
                  />
                  <Detail
                    label="Grupo"
                    value={report.groupNameSamasc || 'Sem grupo'}
                  />
                  <Detail
                    label="Atualização dos dados"
                    value={report.refresh_frequency || 'Não informada'}
                  />
                </Stack>

                {report.glossary && (
                  <Box>
                    <Text
                      fontWeight="bold"
                      color="gray.400"
                      fontSize="small"
                      mb="2"
                    >
                      TERMOS DO RELATÓRIO
                    </Text>
                    <Text fontSize="sm" whiteSpace="pre-wrap">
                      {report.glossary}
                    </Text>
                  </Box>
                )}
              </Stack>
            </TabPanel>

            <TabPanel p="0">
              <CommentsPanel report={report} currentPage={currentPage} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </DrawerBody>
    </DrawerComponent>
  );
}
